import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=db3f58dc&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=db3f58dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3f58dc",
  null
  
)

export default component.exports